import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// --- Meta Pixel Code ---
(function initMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  const s = document.getElementsByTagName("script")[0];
  s.parentNode?.insertBefore(t, s);
})();
const fbq = (window as any).fbq;
if (fbq) {
  fbq("init", "1364665615766923");
  fbq("track", "PageView");
}
// --- End Meta Pixel Code ---

// --- UTMify UTM Tracking Script ---
// Captures UTM parameters on every page load and forwards conversion
// attribution to UTMify. Injected globally, before the app renders.
(function initUtmify() {
  const SRC = "https://cdn.utmify.com.br/scripts/utms/latest.js";
  if (document.querySelector(`script[src="${SRC}"]`)) return;
  const script = document.createElement("script");
  script.src = SRC;
  script.async = true;
  script.defer = true;
  script.setAttribute("data-utmify-prevent-xcod-sck", "");
  script.setAttribute("data-utmify-prevent-subid", "");
  document.head.appendChild(script);
})();
// --- End UTMify UTM Tracking Script ---

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-242" data-mp="1oe4xtg2l4pvj" />);
}